import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getQuestion, setQuestion } from '../../globals/application';
import RichEditor from '../RichEditor';

export default function Question({ showEquationButton = false }) {
  const dispatch = useDispatch();
  const question = useSelector(getQuestion);

  return (
    <div className="field-group">
      <label className="field-label">Question Text</label>
      <RichEditor
        value={question}
        onChange={val => dispatch(setQuestion(val))}
        placeholder="Type your question here..."
        minHeight={80}
        showEquationButton={showEquationButton}
      />
    </div>
  );
}
